module.exports = __webpack_public_path__ + "static/img/max_pictgrid21_1080x853.f776577.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid21_1080x853.jpg
// module id = Ixmi
// module chunks = 0